import './style/datepicker.scss';
import './style/dateRangePicker.scss';
import './style/resume.scss';
import './style/style.scss';
import 'react-date-range/dist/styles.css'; // main style
import 'react-date-range/dist/theme/default.css'; // theme style

import LockIcon from '@mui/icons-material/Lock';
import LoadingToRedirect from 'components/LoadingToRedirect';
import MarketerRoutes from 'config/routes/MarketerRoutes';
import PrivateRoutes from 'config/routes/PrivateRoutes';
import PublicRoutes from 'config/routes/PublicRoutes';
import RecruiterRoutes from 'config/routes/RecruiterRoutes';
import SalesRoutes from 'config/routes/SalesRoutes';
import { useGlobalSSEHandler } from 'hooks/useGlobalSSEHandler';
import { useSSEConnection } from 'hooks/useSSE';
import _ from 'lodash';
import { TeamUserRoles } from 'pages/iPriseV2/common/enum/TeamUserRoles';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BusinessHeadRoutes from 'routes/business-head.routes';
import ManagementRoutes from 'routes/management.routes';
import ManagerRoutes from 'routes/manager.routes';
import RecruiterRoutesV2 from 'routes/recruiter.routes';
import SupportRoutes from 'routes/support.routes';
import TeamLeadRoutes from 'routes/team-lead.routes';
import { logout, ssoLogout } from 'store/actions/UserAction';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { USER_LOGIN_SUCCESS } from 'store/types/UserTypes';
import Storage from 'utils/Storage';

const App: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const dispatch = useAppDispatch();
  const {
    userInfo: userDetail,
    isRestricted,
    isPortalError,
  }: any = useAppSelector((store: any) => store.userLogin);
  const TokenStatus = Storage.getTokens();

  // Initialize SSE connection
  useSSEConnection(userDetail?.token || TokenStatus?.token);
  // Handle global events (toasts/refreshes)
  useGlobalSSEHandler();

  const logoutHandler = async () => {
    await ssoLogout();
    dispatch(logout(true));
    // // e.preventDefault();
    // dispatch({
    //   type: USER_LOGOUT,
    // });
    // localStorage.clear();
    // Storage.removeItem(Storage.KEYS.AUTH_TOKEN);
    // Storage.removeItem(Storage.KEYS.MENUS);
  };

  const handleAppEntry = useCallback(() => {
    if (!_.isEmpty(TokenStatus)) {
      dispatch({
        payload: Storage.isTokenValidDetails(),
        type: USER_LOGIN_SUCCESS,
      });
    } else {
      searchParams.get('hashKey') === '' && navigate('/login');
    }
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setLoading(true);
    handleAppEntry();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Helper function to get the appropriate routes for recruiter role
  const getRecruiterRoutes = () => {
    switch (userDetail?.teamUserRole) {
      case TeamUserRoles.TEAM_LEADER:
        return <TeamLeadRoutes />;
      case TeamUserRoles.MANAGER:
        return <ManagerRoutes />;
      case TeamUserRoles.BUSINESS_HEAD:
        return <BusinessHeadRoutes />;
      case TeamUserRoles.RECRUITER:
        return <RecruiterRoutesV2 />;
      case TeamUserRoles.SUPPORT:
        return <SupportRoutes />;
      case TeamUserRoles.MANAGEMENT:
        return <ManagementRoutes />;
      default:
        return <RecruiterRoutes />;
    }
    // return <RecruiterRoutes />;
  };

  if (isRestricted || isPortalError?.show) {
    return (
      <div className="main-container">
        <LockIcon sx={{ fontSize: '65px' }} />
        <div className="denied">Access to this application is restricted</div>
        <div className="f-18">
          {isPortalError?.message
            ? isPortalError?.message
            : 'Please check with your Administrator'}
        </div>
        <div className="back-to">
          <div>Back To</div>{' '}
          <span className="login" onClick={() => logoutHandler()}>
            {' '}
            Login{' '}
          </span>
        </div>
      </div>
    );
  }
  if (loading) {
    return <LoadingToRedirect />;
  }
  return !_.isEmpty(userDetail) ? (
    <div>
      {/* Admin logins */}
      {userDetail?.roleId === 1 && <PrivateRoutes />}

      {/* Recruiter logins */}
      {userDetail?.roleId === 3 && getRecruiterRoutes()}

      {/* Marketer logins */}
      {userDetail?.roleId === 4 && <MarketerRoutes />}

      {/* Sales logins */}
      {userDetail?.roleId === 5 && <SalesRoutes />}
    </div>
  ) : (
    <PublicRoutes />
  );
};

export default App;
